import { restClient } from '@/Core'

export interface CreateExecutorAssignmentPayload {
    executor: string
    isHired: boolean
    cluster?: string
    region?: string
    carrier?: string
    driver?: string
    vehicle?: string
    plannedLoadingDate?: string
    totalWeightTonnes?: number
    tripsCount?: number
    eWaybillNumber?: string
}

export const CreateExecutorAssignmentTask = async (payload: CreateExecutorAssignmentPayload): Promise<any> => {
    return restClient.post('/services/executor-assignments', { json: payload })
}
